import { render, staticRenderFns } from "./FeatureGrid.vue?vue&type=template&id=005643a6&scoped=true"
import script from "./FeatureGrid.vue?vue&type=script&lang=ts"
export * from "./FeatureGrid.vue?vue&type=script&lang=ts"
import style0 from "./FeatureGrid.vue?vue&type=style&index=0&id=005643a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005643a6",
  null
  
)

export default component.exports